import { IonPopover, IonText } from '@ionic/react';
import { ReactNode, useState } from 'react';

import styles from '@components/fieldsNative/NestedSelect.module.css';
import Icon from '@components/text/Icon';
import { IconName } from '@utils/iconUtils';

export type Item = {
  icon?: IconName;
  label: string;
  value: string;
};

type Props = {
  children: ReactNode;
  items: Map<string, Item[]>;
  onSelect: (item: Item) => void;
};

type PopoverState = {
  event: React.MouseEvent<HTMLDivElement, MouseEvent> | undefined;
  open: boolean;
};

const NestedSelect = ({ children, items, onSelect }: Props) => {
  const [popoverState, setPopoverState] = useState<PopoverState>({ event: undefined, open: false });

  const handlePopoverOpen = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (items.size > 0) {
      setPopoverState({
        event: e,
        open: true
      });
    }
  };

  return (
    <div>
      <IonPopover
        className={styles.popover}
        event={popoverState.event}
        isOpen={popoverState.open}
        onDidDismiss={() => setPopoverState({ event: undefined, open: false })}
      >
        <div className={styles.popoverWrapper}>
          {Array.from(items, ([key, options]) => (
            <div id={key} key={key}>
              <div className={styles.popoverItem}>
                <IonText>{key}</IonText>
                <Icon icon="chevronRight" />
              </div>
              <IonPopover className={styles.noScroll} dismissOnSelect={true} side="top" trigger={key}>
                <div className={styles.nestedPopoverWrapper}>
                  {options.map(option => (
                    <div className={styles.popoverItem} key={option.value} onClick={() => onSelect(option)}>
                      <IonText>{option.label}</IonText>
                      {option.icon && (
                        <div>
                          <Icon color="gray" icon={option.icon} size="small" spacingStart />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </IonPopover>
            </div>
          ))}
        </div>
      </IonPopover>
      <div className={styles.eventCatcher} onClick={handlePopoverOpen}>
        {children}
      </div>
    </div>
  );
};

export default NestedSelect;
